export enum ErrorCodes {
  Unknown = 10000,
  InvalidGrant = 1,
  RequestInvalid = 2,
  Offline = 3,
  FailedRequest = 4,
  Unauthorized = 5,
  BadRequest = 6,
  NotFound = 7,
  ServerError = 8,
  Forbidden = 9,

  GeneralException = 100,

  EmployeeNotFound = 10024,
  PinIsIncorrect = 10025,
  UserIsInNotActive = 10026,

  // Task
  TaskDateTooOld = 12002,
  ValidationMsgExceededMaximumHoursLimitPerTask = 12003,
}
